module.exports = __webpack_public_path__ + "assets/audio/e5bb5fe503796a7494c4526a16ea8a20.wav";